import { Box, FormLabel, Flex, Spinner } from '@chakra-ui/react';

import Loader from 'components/Loader';
import { ReactSelectAsyncPaginate } from 'components/ReactSelect';
import Title from 'components/Title';
import { useFetchUKGEarnings } from 'hooks/integrations/ukg/useFetchUKGEarnings';
import { fetchUKGPaginatedPaycodes } from 'hooks/integrations/ukg/useFetchUKGPaycodes';
import { IMapUKGPaycodes, useMapUKGPaycodes } from 'hooks/integrations/ukg/useMapUKGPaycodes';
import { getAsyncSelectLoadOptions } from 'utils/helpers';

const UKGPaycodes = () => {
  const { status: mapPaycodeStatus, mutateAsync: mutateAsyncMapEarnings } = useMapUKGPaycodes();
  const { status: earningsStatus, data: earningsData, refetch } = useFetchUKGEarnings();

  const earningCodesLoadOptions = (search: any, _: any, { page }: any) => {
    return getAsyncSelectLoadOptions(fetchUKGPaginatedPaycodes, { page, search });
  };

  const onEarningCodeSelected = (earning: any) => {
    const postData: IMapUKGPaycodes = {
      ukg_paycode_id: earning?.id,
      timeero_code: 'H',
    };
    mutateAsyncMapEarnings(postData).then(() => {
      refetch();
    });
  };

  return (
    <Box>
      <Title>UKG Paycodes</Title>

      {earningsStatus === 'success' ? (
        <Box maxWidth="340px" mt="10">
          <FormLabel>Total Hours</FormLabel>
          <Box position="relative" mb="4">
            {mapPaycodeStatus === 'loading' && (
              <Flex
                width="100%"
                height="100%"
                position="absolute"
                zIndex={2}
                justifyContent="center"
                alignItems="center"
                background="rgba(255, 255, 255, 0.7)"
              >
                <Spinner size="xs" />
              </Flex>
            )}
            <ReactSelectAsyncPaginate
              loadOptions={earningCodesLoadOptions}
              value={earningsData?.payload?.hours?.earnings || null}
              additional={{
                page: 1,
              }}
              onChange={(value: any) => {
                onEarningCodeSelected(value);
              }}
              isLoading={true}
              size="md"
              variant="filled"
              fontSize="sm"
              width="100%"
              debounceTimeout={300}
              menuPortalTarget={document.body}
              isSearchable
              placeholder="Select Paycode to map"
              getOptionLabel={(option: any) => option.code + ' - ' + option.description}
              getOptionValue={(option: any) => option.id}
            />
          </Box>
        </Box>
      ) : (
        <Loader />
      )}
    </Box>
  );
};
export default UKGPaycodes;
